//#region src/card_scheme_id.ts
var CardSchemeId = /* @__PURE__ */ function(CardSchemeId) {
	CardSchemeId[CardSchemeId["Other"] = 0] = "Other";
	CardSchemeId[CardSchemeId["Visa"] = 1] = "Visa";
	CardSchemeId[CardSchemeId["MasterCard"] = 2] = "MasterCard";
	CardSchemeId[CardSchemeId["Maestro"] = 3] = "Maestro";
	CardSchemeId[CardSchemeId["AmEx"] = 4] = "AmEx";
	CardSchemeId[CardSchemeId["JCB"] = 5] = "JCB";
	CardSchemeId[CardSchemeId["Diners"] = 6] = "Diners";
	CardSchemeId[CardSchemeId["Discover"] = 7] = "Discover";
	CardSchemeId[CardSchemeId["Voyager"] = 10] = "Voyager";
	CardSchemeId[CardSchemeId["ChinaUnionPay"] = 12] = "ChinaUnionPay";
	CardSchemeId[CardSchemeId["Cash"] = 100] = "Cash";
	CardSchemeId[CardSchemeId["Debit"] = 1240] = "Debit";
	CardSchemeId[CardSchemeId["Interac"] = 1241] = "Interac";
	CardSchemeId[CardSchemeId["EbtCashBenefit"] = 1242] = "EbtCashBenefit";
	CardSchemeId[CardSchemeId["EbtFoodStamp"] = 1243] = "EbtFoodStamp";
	CardSchemeId[CardSchemeId["AthMovil"] = 1244] = "AthMovil";
	CardSchemeId[CardSchemeId["SquareGiftCard"] = 10001] = "SquareGiftCard";
	CardSchemeId[CardSchemeId["SquareEftPos"] = 10002] = "SquareEftPos";
	CardSchemeId[CardSchemeId["TCC"] = 67101] = "TCC";
	CardSchemeId[CardSchemeId["LevelUpDiscount"] = 67102] = "LevelUpDiscount";
	CardSchemeId[CardSchemeId["LevelUpGiftCard"] = 67103] = "LevelUpGiftCard";
	CardSchemeId[CardSchemeId["LevelUpCreditCard"] = 67104] = "LevelUpCreditCard";
	CardSchemeId[CardSchemeId["Givex"] = 67105] = "Givex";
	CardSchemeId[CardSchemeId["Atrium"] = 67106] = "Atrium";
	CardSchemeId[CardSchemeId["Archer"] = 67107] = "Archer";
	CardSchemeId[CardSchemeId["PinataStoredValue"] = 67108] = "PinataStoredValue";
	CardSchemeId[CardSchemeId["Valutec"] = 67109] = "Valutec";
	CardSchemeId[CardSchemeId["PaytronixGiftCard"] = 67110] = "PaytronixGiftCard";
	CardSchemeId[CardSchemeId["OLOGiftCard"] = 67111] = "OLOGiftCard";
	CardSchemeId[CardSchemeId["WorldpayGiftCard"] = 67112] = "WorldpayGiftCard";
	CardSchemeId[CardSchemeId["FreedomPayGiftCard"] = 67113] = "FreedomPayGiftCard";
	CardSchemeId[CardSchemeId["EigenGiftCard"] = 67114] = "EigenGiftCard";
	CardSchemeId[CardSchemeId["ChoptDiscount"] = 67115] = "ChoptDiscount";
	CardSchemeId[CardSchemeId["ChoptGiftCard"] = 67116] = "ChoptGiftCard";
	CardSchemeId[CardSchemeId["ChoptCreditCard"] = 67117] = "ChoptCreditCard";
	CardSchemeId[CardSchemeId["ComoPointRedemption"] = 67118] = "ComoPointRedemption";
	CardSchemeId[CardSchemeId["Cbord"] = 67119] = "Cbord";
	CardSchemeId[CardSchemeId["ThanxReward"] = 67120] = "ThanxReward";
	CardSchemeId[CardSchemeId["ThanxPointRedemption"] = 67121] = "ThanxPointRedemption";
	CardSchemeId[CardSchemeId["PunchhCreditCard"] = 67122] = "PunchhCreditCard";
	CardSchemeId[CardSchemeId["PunchhGiftCard"] = 67123] = "PunchhGiftCard";
	CardSchemeId[CardSchemeId["PunchhDiscount"] = 67124] = "PunchhDiscount";
	CardSchemeId[CardSchemeId["PinataCreditCard"] = 67125] = "PinataCreditCard";
	CardSchemeId[CardSchemeId["PinataLoyaltyGiftCard"] = 67126] = "PinataLoyaltyGiftCard";
	CardSchemeId[CardSchemeId["PinataDiscount"] = 67127] = "PinataDiscount";
	CardSchemeId[CardSchemeId["ParPayGiftCard"] = 67128] = "ParPayGiftCard";
	CardSchemeId[CardSchemeId["SmoothCommercePayment"] = 67129] = "SmoothCommercePayment";
	CardSchemeId[CardSchemeId["SpendgoReward"] = 67130] = "SpendgoReward";
	CardSchemeId[CardSchemeId["StarbucksStoredValue"] = 67131] = "StarbucksStoredValue";
	CardSchemeId[CardSchemeId["StarbucksInAppPayment"] = 67132] = "StarbucksInAppPayment";
	CardSchemeId[CardSchemeId["AtriumMealExchange"] = 67133] = "AtriumMealExchange";
	CardSchemeId[CardSchemeId["LovesRewardsPoints"] = 67134] = "LovesRewardsPoints";
	CardSchemeId[CardSchemeId["LovesDrinkRefills"] = 67135] = "LovesDrinkRefills";
	CardSchemeId[CardSchemeId["PinataCampusCard"] = 67136] = "PinataCampusCard";
	CardSchemeId[CardSchemeId["Quickcharge"] = 67137] = "Quickcharge";
	CardSchemeId[CardSchemeId["FreedomPayStoredValue"] = 67138] = "FreedomPayStoredValue";
	CardSchemeId[CardSchemeId["FreedomPayVoucher"] = 67139] = "FreedomPayVoucher";
	CardSchemeId[CardSchemeId["AppfrontPayment"] = 67140] = "AppfrontPayment";
	CardSchemeId[CardSchemeId["TransactCampusCard"] = 67141] = "TransactCampusCard";
	CardSchemeId[CardSchemeId["AppfrontReward"] = 67142] = "AppfrontReward";
	CardSchemeId[CardSchemeId["GivexLoyaltyReward"] = 67143] = "GivexLoyaltyReward";
	CardSchemeId[CardSchemeId["GivexLoyaltyPayment"] = 67144] = "GivexLoyaltyPayment";
	CardSchemeId[CardSchemeId["ECardSystems"] = 67145] = "ECardSystems";
	return CardSchemeId;
}(CardSchemeId || {});
//#endregion
export { CardSchemeId };

//# sourceMappingURL=card_scheme_id.js.map